import React, { useState } from "react";
import styles from "./index.modules.less";
import { CopyToClipboard } from "react-copy-to-clipboard";
import classNames from "classnames";

const CardInfo = ({ data, style, hideCard, pRef }) => {
  const [copied, setCopied] = useState(false);
  const showCard = () => {
    pRef.current && clearTimeout(pRef.current);
  };
  return (
    <div
      onMouseEnter={() => showCard()}
      onMouseLeave={hideCard}
      style={style}
      className={styles.CardInfo}
    >
      <div className={styles.cardTop}>
        <div className={styles.cardinfoItem}>
          <div className={styles.cardTit}>软件ID：</div>
          <div className={styles.cardVal}>{data.soft_id}</div>
        </div>
        <div className={styles.cardinfoItem}>
          <div className={styles.cardTit}>key：</div>
          <div className={styles.cardVal}>11010231</div>
        </div>
        <div className={styles.cardinfoItem}>
          <div className={styles.cardTit}>Secret：</div>
          <div className={styles.cardVal}>AICGDSDSDSDSDD</div>
        </div>
      </div>

      <CopyToClipboard
        onCopy={() => setCopied(true)}
        text={`软件ID-${data.soft_id}, key-11010231, Secret-AICGDSDSDSDSDD`}
      >
        <div className={styles.cardBottom}>
          <span className={classNames({
            [styles.bulue]: copied
          })}>复制信息</span>
        </div>
      </CopyToClipboard>
    </div>
  );
};

export default CardInfo;
